import React, { useEffect, useState, createContext } from 'react';
import { useMemberstack } from "@memberstack/react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

import IntercomProvider from './components/IntercomProvider';
//page
import Inscription from './Inscription';
import InscriptionVendeur from './InscriptionVendeur';
import AnnonceVendeur from './AnnonceVendeur';
import Invitation from './ConnexionLink';
import Layout from './app/Layout';
import Notaires from './app/Notaires';
import Onboard from './app/Onboard';
import OnboardDone from './app/OnboardDone';
import Mentionslegales from './Mentionslegales';
import Cgu from './Cgu';
import DemoNotaire from './DemoNotaire';
import RelireDocument from './app/RelireDocument';
import Inventaire from './app/Inventaire';

//article fiches BLOG
import CompositionFraisNotaire from './blog/articles/acheteur/CompositionFraisNotaire';
import FichesPratiquesNotaire from './blog/FichesPratiques';
import ArticleRoleNotaire from './blog/ArticleRoleNotaire';
import ArticleDocumentsNotaries from './blog/ArticleDocumentsNotaries';
import ArticleChoisirNotaire from './blog/ArticleChoisirNotaire';
import ArticleDeuxNotaires from './blog/ArticleDeuxNotaires';
import ArticleChecklist from './blog/ArticleChecklistEtapesVente';
import ArticleRegimeMatrimonial from './blog/articles/mariage/ArticleRegimeMatrimonial';
import ArticleEtapeContratMariage from './blog/articles/mariage/ArticleEtapeContratMariage';
import ArticlePourquoiContratMariage from './blog/articles/mariage/ArticlePourquoiContratMariage';
import ArticleDocVenteImmo from './blog/articles/vendeur/ArticleDocVenteImmo';
import ArticleFraisVenteImmo from './blog/articles/vendeur/ArticleFraisVenteImmo';
import ArticleRoleNotaireVenteImmo from './blog/articles/vendeur/ArticleRoleNotaireVenteImmo';
import ArticleCompromisVente from './blog/articles/vendeur/ArticleCompromisVente';
import ArticleCasPrevoirContratMariage from './blog/articles/mariage/ArticleCasPrevoirContratMariage';
import ArticleEffetContratEvenementsMajeurs from './blog/articles/mariage/ArticleEffetContratEvenementsMajeurs';
import Article73coupleRegret from "./blog/articles/mariage/Article73coupleRegret"
import ArticleRegimeSeparationDeBien from "./blog/articles/mariage/ArticleRegimeSeparationDeBien"



//annuaire
import AllNotaires from './annuaire/HomeAnnuaire'
import NotairesRegions from './annuaire/NotaireRegions';
import NotaireVilleParis from './annuaire/notaire-ville/NotaireVilleParis';
import FicheNotaire from './annuaire/FicheNotaire';
import CompetencesNotaire from './blog/CompetencesNotaire';
import ArticleEtapesAchatImmo from './blog/articles/acheteur/ArticleEtapesAchatImmo';
import NotairesVilleLyon from './annuaire/notaire-ville/NotaireVilleLyon';
import NotairesVilleLille from './annuaire/notaire-ville/NotaireVilleLille';
import NotairesVilleBordeaux from './annuaire/notaire-ville/NotaireVilleBordeaux';
import NotairesVilleRennes from './annuaire/notaire-ville/NotaireVilleRennes';
import NotairesVilleMarseille from './annuaire/notaire-ville/NotaireVilleMarseille';
import NotairesVilleStrasbourg from './annuaire/notaire-ville/NotaireVilleStrasbourg';
import NotairesVilleMontpellier from './annuaire/notaire-ville/NotaireVilleMontpellier';
import NotairesVilleToulouse from './annuaire/notaire-ville/NotaireVilleToulouse';
import NotairesVilleAutres from './annuaire/notaire-ville/NotaireVilleAutres';
import HomeAnnuaire from './annuaire/HomeAnnuaire';
import Home from './Home';
import Test from './components/New';
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./NotFound";

//lead page
import FaireDonation from './leadPage/FaireDonation';
import Acheteur from './leadPage/Acheteur';
import Pma from './leadPage/Pma';
import Pacs from './leadPage/Pacs';
import Divorce from './leadPage/Divorce';
import Adoption from './leadPage/Adoption';
import Mariage from './leadPage/Mariage';
import MariageLead from './leadPage/Mariage2';
import Vendeur from './leadPage/Vendeur';
import SoulteLiquidatif from './leadPage/SoulteLiquidatif';
import PageSuccessLead from './leadPage/PageSuccessLead';
import PageSuccessLeadMariage from './leadPage/PageSuccessLeadMariage';
import PageSuccessLeadAcheteur from './leadPage/PageSuccessLeadAcheteur';
import PoserUneQuestionNotaire from './PoserUneQuestionNotaire'

//outils 
import CalculateurPrixContratMariage from './outils/CalculateurPrixContratMariage';
import CalculateurFraisDeNotaire from './outils/CalculFraisNotaire';


//site petite annonce
import HomeVente from './vente/HomeVente';
import PublierAnnonce from './vente/PublierAnnonce';
import Annonce from './vente/Annonce';
import Blog from './blog/Blog';
import Outils from './blog/Outils';
import ArticleDivorceSansContratMariage from './blog/articles/mariage/ArticleDivorceSansContratMariage';
import ArticleAvantagesJuridiquesPacsNotaire from './blog/articles/pacs/ArticleAvantagesJuridiquesPacsNotaire';
import ArticleEtapesPacsNotaire from './blog/articles/pacs/ArticleEtapesPacsNotaire';
import ArticleClausesPacs from './blog/articles/pacs/ArticleClausesPacs';
import ArticleToutSavoirPacs from './blog/articles/pacs/ArticleToutSavoirPacs';


export const userInfoContext = createContext();

const App = () => {
  const [userInfo, setUserInfo] = useState(null);
  const memberstack = useMemberstack();
  //console.log("path", window.location.pathname );

  // récuperation user info - creation context
  useEffect(() => {
    const fetchUserInfo = async () => {
      const { data: member } = await memberstack.getCurrentMember();

      if (member && member.metaData?.airtable_id) {
        const airtableId = member.metaData.airtable_id;

        try {
          const res = await fetch(`https://api.airtable.com/v0/appD48APNaGA4GN0B/user/${airtableId}`, {
            headers: {
              Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
              'content-type': 'application/x-www-form-urlencoded',
              "Accept": "application/json, text/plain, /"
            },
          });

          const data = await res.json();

          if (data?.fields) {
            setUserInfo({
              ...data.fields,
              memberstack_id: member.id,
              email: member.auth?.email,
            });
          }
        } catch (err) {
          console.error("Erreur lors du fetch Airtable :", err);
        }
      }
    };

    fetchUserInfo();
  }, []);


  function getNavbar() {
    if (window.location.pathname === "/app/") {
      return "";
    } else if (window.location.pathname === "/app") {
      return "";

    } else if (window.location.pathname === "/app/dashboard") {
      return "";

    } else if (window.location.pathname === "/app/bien") {
      return "";
    } else if (window.location.pathname === "/app/interlocuteurs") {
      return "";
    } else if (window.location.pathname === "/app/documents") {
      return "";
    } else if (window.location.pathname === "/app/transactions") {
      return "";
    }
    else if (window.location.pathname === "/app/profil") {
      return "";
    } else {
      return "";
    }
  }

  //console.log("user data",userInfo)
  return (
    <>

      <Router>
        <ScrollToTop />
        <userInfoContext.Provider value={{ userInfo, setUserInfo }}>
          <IntercomProvider user={userInfo} />

          {getNavbar()}

          <Routes>
            <Route index element={<Home />} user={userInfo} />
            <Route path="trouver-votre-notaire" element={<HomeAnnuaire />} user={userInfo} />
            <Route path="inscription/:type" element={<Inscription />} user={userInfo} />
            <Route path="vendeur" element={<Vendeur />} user={userInfo} />
            <Route path="vendeur/onboard" element={<InscriptionVendeur />} user={userInfo} />
            <Route path=":id" element={<AnnonceVendeur />} user={userInfo} />
            <Route path="connexion" element={<Invitation />} user={userInfo} />
            {/** APP */}
            <Route path="app" element={<Layout />} user={userInfo} />
            <Route path="onboard/:type" element={<Onboard />} user={userInfo} />
            {/**<Route path="app/notaires" exact element={<Notaires />} user={userInfo} />**/}
            <Route path="app/notaires/:type/:id" exact element={<Notaires />} user={userInfo} />
            <Route path="app/dashboard" exact user={userInfo} element={<Layout />} />
            <Route path="app/bien" exact user={userInfo} element={<Layout />} />
            <Route path="app/interlocuteurs" exact user={userInfo} element={<Layout />} />
            <Route path="app/documents" exact user={userInfo} element={<Layout />} />
            <Route path="app/notaire" exact user={userInfo} element={<Layout />} />
            <Route path="app/message" exact user={userInfo} element={<Layout />} />
            <Route path="app/dashboard-donation" exact user={userInfo} element={<Layout />} />
            <Route path="app/contact-donation" exact user={userInfo} element={<Layout />} />
            <Route path="app/document-donation" exact user={userInfo} element={<Layout />} />
            <Route path="app/dashboard-annonce" exact user={userInfo} element={<Layout />} />
            <Route path="app/dashboard-annonce-notaire" exact user={userInfo} element={<Layout />} />
            <Route path="app/dashboard-annonce-2" exact user={userInfo} element={<Layout />} />
            <Route path="app/dashboard-pma" exact user={userInfo} element={<Layout />} />
            <Route path="app/document-pma" exact user={userInfo} element={<Layout />} />
            <Route path="app/notaire-pma" exact user={userInfo} element={<Layout />} />
            <Route path="app/dashboard-mariage" exact user={userInfo} element={<Layout />} />
            <Route path="app/document-mariage" exact user={userInfo} element={<Layout />} />
            <Route path="app/notaire-mariage" exact user={userInfo} element={<Layout />} />
            <Route path="app/dashboard-pacs" exact user={userInfo} element={<Layout />} />
            <Route path="app/document-pacs" exact user={userInfo} element={<Layout />} />
            <Route path="app/notaire-pacs" exact user={userInfo} element={<Layout />} />
            <Route path="app/dashboard-empty" exact user={userInfo} element={<Layout />} />
            <Route path="app/notaire-empty" exact user={userInfo} element={<Layout />} />
            <Route path="app/profil" exact user={userInfo} element={<Layout />} />
            <Route path="app/relecture/:id_event" exact user={userInfo} element={<RelireDocument />} />
            <Route path="app/inventaire/:type/:id_action" exact user={userInfo} element={<Inventaire />} />

            <Route path="info/mentions-legales" exact user={userInfo} element={<Mentionslegales />} />
            <Route path="info/cgu" exact user={userInfo} element={<Cgu />} />
            <Route path="demo-notaire" exact user={userInfo} element={<DemoNotaire />} />
            {/** Page de lead  **/}
            <Route path="/faire-une-donation" element={<FaireDonation />} user={userInfo} />
            <Route path="/notaire-acheteur" element={<Acheteur />} user={userInfo} />
            <Route path="/notaire-vendeur" element={<Vendeur />} user={userInfo} />
            <Route path="/notaire-divorce" element={<Divorce />} user={userInfo} />
            <Route path="/notaire-pma" element={<Pma />} user={userInfo} />
            <Route path="/notaire-pacs" element={<Pacs />} user={userInfo} />
            <Route path="/notaire-etat-liquidatif" element={<SoulteLiquidatif />} user={userInfo} />
            <Route path="/notaire-reconnaissance-conjointe-enfant" element={<Pma />} user={userInfo} />
            <Route path="/notaire-adoption" element={<Adoption />} user={userInfo} />
            <Route path="/notaire-contrat-mariage" element={<Mariage />} user={userInfo} />
            <Route path="/notaire-pour-contrat-mariage" element={<MariageLead />} user={userInfo} />
            <Route path="/success-notaire-dispo" element={<PageSuccessLead />} user={userInfo} />
            <Route path="/success-notaire-dispo-mariage" element={<PageSuccessLeadMariage />} user={userInfo} />
            <Route path="/success-notaire-dispo-acheteur" element={<PageSuccessLeadAcheteur />} user={userInfo} />
            <Route path="/posez-une-question-a-un-notaire" element={<PoserUneQuestionNotaire />} user={userInfo} />

            {/** Page d'outils **/}
            <Route path="/outils/notaire" element={<Outils />} user={userInfo} />
            <Route path="/outils/calculateur-prix-contrat-mariage" element={<CalculateurPrixContratMariage />} user={userInfo} />
            <Route path="/outils/calculateur-frais-de-notaire-immobilier" element={<CalculateurFraisDeNotaire />} user={userInfo} />


            {/** Articles BLOG **/}
            <Route path="/blog/:categorySlug" element={<Blog />} />
            <Route path="/blog" element={<Navigate to="/blog/notaire-immobilier" />} />
            <Route path="/blog/fiches-pratiques-notaire/" exact user={userInfo} element={<FichesPratiquesNotaire />} />
            <Route path="/fiches-pratiques-notaire/role-du-notaire-en-immobilier" exact user={userInfo} element={<ArticleRoleNotaire />} />
            <Route path="/fiches-pratiques-notaire/un-ou-deux-notaires-immobilier" exact user={userInfo} element={<ArticleDeuxNotaires />} />
            <Route path="/fiches-pratiques-notaire/document-de-vente-notaire" exact user={userInfo} element={<ArticleDocumentsNotaries />} />
            <Route path="/immobilier/notaire/comment-choisir-son-notaire" exact user={userInfo} element={<ArticleChoisirNotaire />} />
            <Route path="/immobilier/notaire/etapes-achat-immobilier" exact user={userInfo} element={<ArticleEtapesAchatImmo />} />
            <Route path="/immobilier/notaire/de-quoi-se-compose-les-frais-de-notaire" exact user={userInfo} element={<CompositionFraisNotaire />} />
            <Route path="blog/notaire/domaines-competences-notaire" exact user={userInfo} element={<CompetencesNotaire />} />
            <Route path="/immobilier/notaire/vendre-seul-son-bien-checklist-etapes-de-vente" exact user={userInfo} element={<ArticleChecklist />} />
            {/** blog mariage */}
            <Route path="/contrat-mariage/notaire/regimes-matrimoniaux" exact user={userInfo} element={<ArticleRegimeMatrimonial />} />
            <Route path="/contrat-mariage/notaire/etapes-contrat-de-mariage" exact user={userInfo} element={<ArticleEtapeContratMariage />} />
            <Route path="/contrat-mariage/notaire/pourquoi-faire-un-contrat-de-mariage" exact user={userInfo} element={<ArticlePourquoiContratMariage />} />
            <Route path="/contrat-mariage/notaire/divorce-sans-contrat-de-mariage" exact user={userInfo} element={<ArticleDivorceSansContratMariage />} />
            <Route path="/contrat-mariage/notaire/dans-quelles-situations-prevoir-un-contrat-de-mariage" exact user={userInfo} element={<ArticleCasPrevoirContratMariage />} />
            <Route path="/contrat-mariage/notaire/les-effets-du-contrat-de-mariage-en-cas-d-evenements-majeurs-divorce-deces" exact user={userInfo} element={<ArticleEffetContratEvenementsMajeurs />} />
            <Route path="/contrat-mariage/notaire/pourquoi-73-des-couples-regrettent-de-ne-pas-avoir-fait-un-contrat-de-mariage" exact user={userInfo} element={<Article73coupleRegret />} />
            <Route path="/contrat-mariage/notaire/contrat-mariage/notaire/regime-matrimonial-separation-de-bien" exact user={userInfo} element={<ArticleRegimeSeparationDeBien />} />
            {/** blog pacs */}
            <Route path="/pacs/notaire/avantages-juridiques-de-votre-convention-de-pacs-chez-le-notaire" exact user={userInfo} element={<ArticleAvantagesJuridiquesPacsNotaire />} />
            <Route path="/pacs/notaire/tout-savoir-sur-la-convention-de-pacs-chez-le-notaire" exact user={userInfo} element={<ArticleToutSavoirPacs />} />
            <Route path="/pacs/notaire/etapes-pacs-notaire" exact user={userInfo} element={<ArticleEtapesPacsNotaire />} />
            <Route path="/pacs/notaire/details-clauses-convention-de-pacs-chez-le-notaire" exact user={userInfo} element={<ArticleClausesPacs />} />


            {/** blog immobilier */}
            <Route path="/immobilier/notaire/documents-vente-notaire" exact user={userInfo} element={<ArticleDocVenteImmo />} />
            <Route path="/immobilier/notaire/frais-vente-notaire" exact user={userInfo} element={<ArticleFraisVenteImmo />} />
            <Route path="/immobilier/notaire/role-notaire-vente-immobilier" exact user={userInfo} element={<ArticleRoleNotaireVenteImmo />} />
            <Route path="/immobilier/notaire/compromis-de-vente" exact user={userInfo} element={<ArticleCompromisVente />} />

            {/** Annuaires **/}
            <Route path="/fr/notaires" user={userInfo} element={<AllNotaires />} />
            <Route path="/trouvez-un-notaire" user={userInfo} element={<AllNotaires />} />
            <Route path="/notaires" user={userInfo} element={<AllNotaires />} />
            <Route path="/fr/notaires/region/ile-de-france" user={userInfo} element={<NotairesRegions />} />
            <Route path="/fr/notaires/ville/paris" user={userInfo} element={<NotaireVilleParis />} />
            <Route path="/fr/notaires/ville/lyon" user={userInfo} element={<NotairesVilleLyon />} />
            <Route path="/fr/notaires/ville/lille" user={userInfo} element={<NotairesVilleLille />} />
            <Route path="/fr/notaires/ville/bordeaux" user={userInfo} element={<NotairesVilleBordeaux />} />
            <Route path="/fr/notaires/ville/montpellier" user={userInfo} element={<NotairesVilleMontpellier />} />
            <Route path="/fr/notaires/ville/rennes" user={userInfo} element={<NotairesVilleRennes />} />
            <Route path="/fr/notaires/ville/toulouse" user={userInfo} element={<NotairesVilleToulouse />} />
            <Route path="/fr/notaires/ville/marseille" user={userInfo} element={<NotairesVilleMarseille />} />
            <Route path="/fr/notaires/ville/strasbourg" user={userInfo} element={<NotairesVilleStrasbourg />} />
            {/** autres url */}
            <Route path="/notaires-a-paris" user={userInfo} element={<NotaireVilleParis />} />
            <Route path="/notaires-a-lyon" user={userInfo} element={<NotairesVilleLyon />} />
            <Route path="/notaires-a-lille" user={userInfo} element={<NotairesVilleLille />} />
            <Route path="/notaires-a-bordeaux" user={userInfo} element={<NotairesVilleBordeaux />} />
            <Route path="/notaires-a-montpellier" user={userInfo} element={<NotairesVilleMontpellier />} />
            <Route path="/notaires-a-rennes" user={userInfo} element={<NotairesVilleRennes />} />
            <Route path="/notaires-a-toulouse" user={userInfo} element={<NotairesVilleToulouse />} />
            <Route path="/notaires-a-marseille" user={userInfo} element={<NotairesVilleMarseille />} />
            <Route path="/notaires-a-strasbourg" user={userInfo} element={<NotairesVilleStrasbourg />} />
            <Route path="/fr/notaires/ville/:nameCity" user={userInfo} element={<NotairesVilleAutres />} />
            <Route path="/notaire/:nom" user={userInfo} element={<FicheNotaire />} />

            {/** site petite annonce*/}
            <Route path="/vendre" exact user={userInfo} element={<HomeVente />} />
            <Route path="/publier-annonce" exact user={userInfo} element={<PublierAnnonce />} />
            <Route path="/annonce" exact user={userInfo} element={<Annonce />} />
            <Route path="/annonce-immobilier-particulier/:region/:id" exact user={userInfo} element={<Annonce />} />

            <Route path="/test" exact user={userInfo} element={<Test />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate replace to="/404" />} />

            {/** after paiement onboard */}
            <Route path="/onboard/done" exact user={userInfo} element={<OnboardDone />} />


          </Routes>
        </userInfoContext.Provider>
      </Router>
    </>
  );
};

export default App;
